import { createContext, useContext } from 'react'

interface AuthLayoutContextType {
  setShowHeaderLogo: (showHeaderLogo: boolean) => void
  setHeaderLogoLinkTo: (headerLogoLinkTo: string) => void
  reset: () => void
}

export const AuthLayoutContext = createContext<AuthLayoutContextType>({
  setShowHeaderLogo: () => {},
  setHeaderLogoLinkTo: () => {},
  reset: () => {},
})

export const useAuthLayoutContext = () => {
  const context = useContext(AuthLayoutContext)
  if (!context) {
    throw new Error('useAuthLayoutContext must be used within an AuthLayoutContextProvider')
  }
  return context
}
